var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0784 27.028C45.4764 27.028 44.679 27.0147 43.6862 27.0147C41.2649 27.0147 39.274 25.0107 39.274 22.5667V18.2787C39.274 17.9413 39.0047 17.6667 38.6707 17.6667H31.6181C28.3268 17.6667 25.6666 20.368 25.6666 23.6787V38.0453C25.6666 41.5187 28.4536 44.3333 31.8927 44.3333H42.395C45.6744 44.3333 48.3333 41.6493 48.3333 38.336V27.628C48.3333 27.2893 48.0653 27.016 47.73 27.0173C47.1662 27.0213 46.4903 27.028 46.0784 27.028Z",
    fill: "#D20E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4454 18.4231C42.0467 18.0084 41.3507 18.2937 41.3507 18.8684V22.3844C41.3507 23.8591 42.5654 25.0724 44.04 25.0724C44.9694 25.0831 46.26 25.0857 47.356 25.0831C47.9174 25.0817 48.2027 24.4111 47.8134 24.0057C46.4067 22.5431 43.888 19.9217 42.4454 18.4231Z",
    fill: "#7E0830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2239 34.8571C40.7719 34.8571 41.2173 35.3024 41.2173 35.8504C41.2173 36.3984 40.7719 36.8424 40.2239 36.8424H32.9653C32.4173 36.8424 31.9733 36.3984 31.9733 35.8504C31.9733 35.3024 32.4173 34.8571 32.9653 34.8571H40.2239ZM37.4785 28.1981C38.0265 28.1981 38.4718 28.6435 38.4718 29.1915C38.4718 29.7395 38.0265 30.1835 37.4785 30.1835H32.9651C32.4171 30.1835 31.9731 29.7395 31.9731 29.1915C31.9731 28.6435 32.4171 28.1981 32.9651 28.1981H37.4785Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.3125,
    y: 0.625,
    width: 73.375,
    height: 73.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.0625,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.3125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.3125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperRounded);
export default __webpack_public_path__ + "static/media/PaperRounded.d96c7fcc.svg";
export { ForwardRef as ReactComponent };